import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Context = createContext({ offer: null, loading: true, refresh: () => {} });

export function FootballPromotionProvider({ children }) {
  const { user } = useAuth();
  const latestUser = useRef(user);
  latestUser.current = user;
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/promotions/football-month${user ? '/account' : ''}`, {
        withCredentials: true, timeout: 15000,
      });
      if (latestUser.current === user) setOffer(data);
    } catch { if (latestUser.current === user) setOffer(null); }
    finally { if (latestUser.current === user) setLoading(false); }
  }, [user]);
  useEffect(() => {
    // Clear private account fields immediately when the member changes.
    setOffer(null);
    setLoading(true);
    refresh();
    const interval = setInterval(refresh, 60000);
    const onFocus = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', onFocus);
    return () => { clearInterval(interval); document.removeEventListener('visibilitychange', onFocus); };
  }, [refresh]);
  return <Context.Provider value={{ offer, loading, refresh }}>{children}</Context.Provider>;
}

export function useFootballPromotion() { return useContext(Context); }
